import { render, staticRenderFns } from "./SubmissionFormOfferDetails.vue?vue&type=template&id=7c657b38&scoped=true&"
import script from "./SubmissionFormOfferDetails.vue?vue&type=script&lang=ts&"
export * from "./SubmissionFormOfferDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c657b38",
  null
  
)

export default component.exports